export { default } from './CustomerInformationForm'
export * from './CustomerInformationForm'
